exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tr.advanced[data-v-3c5ca272]{height:110px}.table td[data-v-3c5ca272]{vertical-align:top}.enable-advanced-settings[data-v-3c5ca272]{line-height:1.8}.relative[data-v-3c5ca272]{position:relative}", ""]);

// exports
